import { render, staticRenderFns } from "./ems.vue?vue&type=template&id=a1990eaa&scoped=true&"
import script from "./ems.vue?vue&type=script&lang=js&"
export * from "./ems.vue?vue&type=script&lang=js&"
import style0 from "./ems.vue?vue&type=style&index=0&id=a1990eaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1990eaa",
  null
  
)

export default component.exports